import { Col, Row } from 'react-bootstrap';
import Markdown from 'react-commonmark';
import { Field } from 'redux-form';
import { CheckboxGroup } from '../../../../../../common/components/ReduxFormField';
import React from 'react';
import { acceptance } from 'redux-form-validators';

export const Declaration = ({ isValid, channelType, declarations }) => {
  if (!isValid) {
    return null;
  }

  const declaration = declarations?.[channelType] ?? '';

  return (
    <div className="declaration-container">
      <Row>
        <Col sm={12}>
          <div className="issue-policy-title padding-title">Declaration</div>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          {declaration ? (
            <div>
              <div className="declaration">
                <Markdown
                  source={declaration}
                  // linkTarget='_blank' transformLinkUri={this.transformDocLinks}
                />
              </div>
            </div>
          ) : (
            <ul>
              <li>The Insured is resident in the United Kingdom.</li>
              <li>Formal instructions have been received to bind cover.</li>
            </ul>
          )}
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <div className="confirm-declaration">
            <Field
              name={'meta.purchase_declaration'}
              inline
              options={[
                {
                  label: 'Please tick to confirm you agree to the above declaration',
                  value: true,
                },
              ]}
              validate={acceptance({ msg: 'Please confirm the above declaration' })}
              component={CheckboxGroup}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};
